// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ModalType } from 'containers/ModalRoot';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/modal';

const initialState = {
  type: null,
  props: {},
};
export type State = {
  type: ModalType | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any>;
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function modal(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'MODAL_SHOW':
      return {
        ...state,
        type: action.payload.type,
        props: action.payload.props,
      };

    case 'MODAL_HIDE':
      return initialState;

    default:
      return state;
  }
}
